import { Box, FormControlLabel, RadioGroup, Radio, MenuItem, Stack, TextField, Button, Backdrop, CircularProgress, Typography } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { banques } from "../asset/variables";
import { API } from "../conf";
import { Context } from "../App";

export default function FedPartVerseForm (props){
    const { updateConnect } = useContext(Context)
    const [load, setLoad] = useState(true)
    const [feam_banques, setFeamBanques] = useState([])
    const [dons, setDons] = useState([])
    const [ref, setRef] = useState('')
    const [date, setDate] = useState('')
    const [montant, setMontant] = useState('')
    const [feam_banque, setFeamBanque] = useState('')
    const [banque, setBanque] = useState('')
    const [num_cheque, setNum_cheque] = useState('')
    const [fedVerseType, setFedVerseType] = useState(props.vers.fedVerseType??'cheque')
    
    const fed_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.dime+
    Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+
    current.offrande_spe_feam.reduce((to,off)=>to+off.montant,0),0), [dons])

    const alreadyVersed = useMemo(()=> 
        [...props.vers?.fedRepartition?.especes, ...props.vers?.fedRepartition?.retrait].reduce((acc, current)=>acc+((current.montant*current.count)??0),0) +
        props.vers?.fedRepartition?.cheques?.reduce((acc, current)=>acc+current.montant,0) +
        (props.vers?.fedRepartition?.virement?.montant??0)
    ,[props.vers]) 

    useEffect(()=>{ setMontant((fed_part-alreadyVersed).toFixed(2))},[fed_part])

    function handleSubmission(e) {
        e.preventDefault(); setLoad(true)
        let body = {}
        if (fedVerseType === 'cheque'){
            body = {...props.vers, fedVerseType, fedRepartition: {cheques: [{banque, num_cheque, montant}]}}
        }else{
            body = {...props.vers, feam_banque, fedVerseType, fedRepartition: {virement: {date, montant, ref}}}
        }
        fetch(API.concat(`/versements/${props.vers._id}`), {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },        
            body: JSON.stringify(body)
        })
        .then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    props.updateVersement(json)
                    setLoad(false)
                }else setLoad(false)
                props.handleClose()
            }
        })
    }

    useEffect(()=>{
        fetch(API.concat('/comptes/federation/banque'),{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        })
        .then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setFeamBanques(json)
                    setLoad(false)
                }else setLoad(false)
            }
        })

        fetch(API.concat(`/dons/by/${JSON.stringify({eglise: props.vers.eglise.number, num:{$in: props.vers.dons}})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    if(!(json.length===dons.length&&json.every(d=>dons.some(don=>don._id===d._id)))){
                        setDons(json);
                    }setLoad(false)
                }else setLoad(false)
            }
        })
    }, [])

    return(
        <Box component='form' onSubmit={handleSubmission} display={"flex"} flexDirection={"column"} paddingInline={3} paddingBottom={3} >
            <RadioGroup row sx={{minWidth:'500px'}} value={fedVerseType} onChange={(event)=> setFedVerseType(event.target.value)}>
                <FormControlLabel value={'cheque'} control={<Radio/>} label={'Chèque'} />
                <FormControlLabel value={'virement'} control={<Radio/>} label={'Virement'} />
            </RadioGroup>

            <Typography color='carmine.main' fontWeight='bold' align="center">La part fédérale s'élève à {fed_part.toFixed(2)}€, vous avez déjà inclus {alreadyVersed.toFixed(2)}€ dans votre versement, il vous reste {(fed_part-alreadyVersed).toFixed(2)}€ à verser, votre paiement complémentaire ne peut être inférieur à ce montant.</Typography>

            {fedVerseType === 'cheque' ? <Box display={"flex"} flexDirection={"column"} rowGap={2}>
                <TextField fullWidth required select label={"Banque"} value={banque} onChange={(e)=> setBanque(e.target.value)}>
                    {banques.map((label, index)=><MenuItem key={index} value={label}>{label}</MenuItem>)}
                </TextField>
                <Stack direction="row" spacing={2}>
                    <TextField fullWidth required label={"Numéro de chèque"} value={num_cheque} onChange={(e)=> setNum_cheque(e.target.value)}/>
                    <TextField fullWidth required label="montant" InputLabelProps={{shrink: true}} inputProps={{step:"0.01", min:'0'}} type="number" value={montant}
                    onFocus={()=>{if(montant===0) setMontant('')}}
                    onChange={(e)=>{if ((/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0)||e.target.value===''){setMontant(e.target.value==='' ? '' : Number(e.target.value))}}}/>
                </Stack>
            </Box> 
            
            : <Box display={"flex"} flexDirection={"column"} rowGap={2}>
                <Stack direction="row" spacing={2}>
                    <TextField fullWidth required type="date" label={"Date"} InputLabelProps={{shrink: true}} inputProps={{max: new Date().toISOString().split("T")[0]}} value={date} onChange={(e)=>setDate(e.target.value)}/>
                    <TextField fullWidth required select label={"Banque FEAM"} value={feam_banque} onChange={(e)=> setFeamBanque(e.target.value)}>
                        {feam_banques.map((fedbq, index)=><MenuItem key={index} value={fedbq.num}>{fedbq.libelle}</MenuItem>)}
                    </TextField>
                </Stack>
                <Stack direction="row" spacing={2}>
                    <TextField fullWidth required label={"Référence"} value={ref} onChange={(e)=>setRef(e.target.value)}/>
                    <TextField fullWidth required label="montant" InputLabelProps={{shrink: true}} inputProps={{step:"0.01", min:'0'}} type="number" value={montant}
                    onFocus={()=>{if(montant===0) setMontant('')}}
                    onChange={(e)=>{if ((/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0)||e.target.value===''){setMontant(e.target.value==='' ? '' : Number(e.target.value))}}}/>
                </Stack>
            </Box>}

            <Button variant="contained" type="submit" disabled={montant<fed_part-alreadyVersed||!['cheque','virement'].includes(fedVerseType)} sx={{marginTop:3, alignSelf:'center'}}>Valider</Button>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}